import { LocationChangeAction, push } from "react-router-redux";
import { ReportUrl, formatDate, getCurrenciesRequest } from "@common";
import { put, select } from "redux-saga/effects";
import { reportParametersForm, validateReportParameters, ReportParametersFormFields } from "../state";
import { AppState } from "@store";
import { reportCampaignListSelector } from "../selector";
import { FetchingState } from "rd-redux-http";

export function* fillReportParametersFormFromUrlParams(action: LocationChangeAction) {
    const urlMatch = ReportUrl.match(action.payload, true);
    const data = urlMatch.isMatched ? { ...(urlMatch.query || {}), ...urlMatch.params } : {};

    /* Convert the type of "const data" so we can 
        validate the dates on form rendering, according to the ticket ACD-470 */
    const dataAsReportParametersFields = data as ReportParametersFormFields;
    const errors = validateReportParameters(dataAsReportParametersFields);

    if (dataAsReportParametersFields && !errors) {
        yield put(reportParametersForm.actions.setData(dataAsReportParametersFields));

        // Set the errors, if any, on render
        yield put(reportParametersForm.actions.setErrors(errors));
    }
}

export function* uploadMappings(action: LocationChangeAction) {
    const appState: AppState = yield select();

    if (FetchingState.isSuccess(appState.mappings.currencies)) {
        return;
    }

    try {
        yield getCurrenciesRequest.saga({});
    } catch (e) {
        console.log(e);
    }
}

export function* updateReportUrlOnChangeReportParams() {
    const appState: AppState = yield select();

    const urlMatch = ReportUrl.match(window.location.toString(), true);
    if (!urlMatch.isMatched) {
        return;
    }

    const data = urlMatch.isMatched
        ? { ...(urlMatch.query || {}), ...urlMatch.params }
        : {
              campaignId: ""
          };

    const formResult = reportParametersForm.selector(appState.reports.form, data);

    if (!formResult.isValid) {
        return;
    }

    // Allow the user to select other campaign even if there is a problem in the date selection according to the ticket ACD-470
    if (formResult.data.campaignId !== data.campaignId) {
        const campaign = reportCampaignListSelector(appState).find(c => c.campaignId === formResult.data.campaignId);

        const dates =
            data.campaignId === formResult.data.campaignId
                ? {
                      fromDate: formResult.data.fromDate,
                      toDate: formResult.data.toDate
                  }
                : {
                      fromDate: formatDate(campaign.startDate),
                      toDate: formatDate(campaign.endDate)
                  };

        yield put(push(ReportUrl.format({ ...(formResult.data as any), tab: urlMatch.params.tab }, dates)));
    }

    const errors = validateReportParameters(formResult.data);

    if (errors) {
        yield put(reportParametersForm.actions.setErrors(errors));
        return;
    } else {
        yield put(reportParametersForm.actions.setErrors(errors));
    }

    const campaign = reportCampaignListSelector(appState).find(c => c.campaignId === formResult.data.campaignId);

    const dates =
        data.campaignId === formResult.data.campaignId
            ? {
                  fromDate: formResult.data.fromDate,
                  toDate: formResult.data.toDate
              }
            : {
                  fromDate: formatDate(campaign.startDate),
                  toDate: formatDate(campaign.endDate)
              };

    yield put(push(ReportUrl.format({ ...(formResult.data as any), tab: urlMatch.params.tab }, dates)));
}
